// Task 4.2 — minimal route-transition loading fallback for the lazy-loaded page
// chunks (React.lazy/Suspense in App.js). Deliberately tiny: a centered, gently
// pulsing brand bracket mark on the site's own base surface, using existing
// tokens — NOT a new visual system. It only shows for the brief moment a route's
// JS chunk is still downloading (offscreen/instant on a warm cache), so it must
// not shift layout or flash a jarring colour. Respects reduced motion via the
// global index.css guard (the pulse is a Tailwind `animate-pulse`, collapsed to
// static there). The one-time cold-load beat is handled separately by
// LoadingReticle (App.js); this is only the per-navigation chunk-load gap.
export default function RouteFallback() {
  return (
    <div
      className="min-h-screen bg-surface-base flex items-center justify-center"
      role="status"
      aria-label="Loading"
    >
      <div className="animate-pulse font-mono text-2xl font-extrabold tracking-tight text-brand-cyan/70 select-none">
        <span aria-hidden="true">{'[ '}</span>
        MockWit
        <span aria-hidden="true">{' ]'}</span>
      </div>
    </div>
  );
}
